import { render, staticRenderFns } from "./ConfigureDocumentField.vue?vue&type=template&id=d4da25aa&scoped=true"
import script from "./ConfigureDocumentField.vue?vue&type=script&lang=js"
export * from "./ConfigureDocumentField.vue?vue&type=script&lang=js"
import style0 from "./ConfigureDocumentField.vue?vue&type=style&index=0&id=d4da25aa&prod&scoped=true&lang=css"
import style1 from "./ConfigureDocumentField.vue?vue&type=style&index=1&id=d4da25aa&prod&scoped=true&lang=css"
import style2 from "./ConfigureDocumentField.vue?vue&type=style&index=2&id=d4da25aa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4da25aa",
  null
  
)

export default component.exports